import { Box } from "@mui/material";
import PropTypes from "prop-types";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { authState } from "../recoil/authState";
import { trackPageView } from "../analytics/analytics";

import Header from "./header";
import Nav from "./nav";
import Main from "./main";

export default function Layout({ children }) {
  const location = useLocation();
  const auth = useRecoilValue(authState);

  // 페이지 경로 변경 시 골프장 정보와 함께 페이지 뷰 로깅
  // route change 감지하여 1회만 page_view 기록
  useEffect(() => {
    // 로그인 페이지는 제외
    if (location.pathname === '/login' || location.pathname === '/repassword') {
      return;
    }
    
    // 로그인하지 않은 상태에서는 추적하지 않음
    if (!auth?.isLoggedIn || !auth?.user) {
      return;
    }
    
    // 페이지 이름 생성 (경로 기반)
    const getPageName = (pathname) => {
      const pathMap = {
        '/home': '홈',
        '/dc/bookingdiscountList': '할인예약 목록',
        '/dc/bookingdiscountList/create': '할인예약 등록',
        '/dc/bookingdiscountrsvps': '할인예약 예약자',
        '/common/golfinfo': '골프장 정보',
        '/common/golfinfo/modify': '골프장 정보 수정',
        '/common/golfinfo/event': '이벤트',
        '/common/golfinfo/event/create': '이벤트 등록',
        '/common/golfacount': '골프장 계정관리',
        '/analytics/timeline': '타임라인',
        '/common/logList': '로그 목록',
        '/yb/yearBookingList': '연단체 예약 목록',
        '/yb/yearBookingGroups': '연단체 그룹 관리',
        '/eb/eventBookingList': '월단체 예약 목록',
        '/eb/eventBookingRoundingList': '월단체 라운딩 목록',
        '/erp/erpBookingList': 'ERP 예약 목록',
        '/search': '검색 결과',
      };

      // 정확한 경로 매칭 우선 (더 구체적인 경로부터 확인)
      const sortedPaths = Object.entries(pathMap).sort((a, b) => b[0].length - a[0].length);
      
      for (const [path, name] of sortedPaths) {
        if (pathname === path || pathname.startsWith(path + '/')) {
          return name;
        }
      }

      // 기본값: 경로를 페이지 이름으로 사용
      return pathname;
    };

    const pageName = getPageName(location.pathname);
    
    // 페이지 뷰 로깅 (GA4 gtag + Firestore)
    // authState를 직접 전달하여 Recoil state에서 바로 읽도록 함 (localStorage 동기화 지연 방지)
    // gc_id, page_key, page_path가 항상 채워지도록 보장
    // trackPageView 내부에서 중복 방지 로직이 있으므로 안전하게 호출 가능
    trackPageView(pageName, auth);
    
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]); // auth는 의존성에서 제외 (pathname 변경 시에만 추적)

  return (
    <>
      <Header />
      <Box
        sx={{
          minHeight: 1,
          display: "flex",
          // flexDirection: { xs: 'column', lg: 'row' },
          flexDirection: "row",
        }}
      >
        <Nav />
        <Main>{children}</Main>
      </Box>
    </>
  );
}

Layout.prototype = {
  children: PropTypes.node,
};
